export default {
  items: [
    {
      name: "Main dashboard",
      url: "/dashboard",
      icon: "icon-speedometer"
    },
    {
      name: "Asset Schemas",
      url: "/asset-schemas"
    },
    {
      name: "Financical Structure",
      url: "/financical-structure"
    },
    {
      name: "Data Items",
      url: "/seasonability"
    },
    {
      name: "Projects",
      url: "/projects"
    },
    {
      name: "Dealroom",
      url: "/dealroom"
    }

  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js